import stateDictionary from './state-abbreviations.json';

const useStateAbbreviations = (stateName: string) => {
    if (!stateName) {
        return "";
    }
    const key = stateName.trim().toLowerCase() as keyof typeof stateDictionary;
    return stateDictionary[key] || stateName;
}

const useNormalizePostalCode = (postalCode: string) => {
    if (!postalCode || postalCode.length === 0) {
        return '';
    }
    // Match 5 digits, 5+4 with dash, or 5+4 with space
    const isUSZipCode = /^[0-9]{5}([ -][0-9]{4})?$/.test(postalCode);
    return isUSZipCode ? postalCode.slice(0, 5) : postalCode.toUpperCase();
}

// Remove last comma and everything after (e.g., "Grand Rapids, MI, United States" -> "Grand Rapids, MI")
const stripCountry = (text: string) => {
    const lastComma = text.lastIndexOf(",");
    if (lastComma === -1) return text;
    return text.slice(0, lastComma).trim();
};


export { useStateAbbreviations, useNormalizePostalCode, stripCountry }
